<div class="billing-settings page-shell">
  <mat-toolbar class="header">
    <span>{{ "settings.billing.header" | translate }}</span>
    <div class="header-buttons">
      <button
        *ngIf="auth.isSuperAdmin"
        mat-raised-button
        type="button"
        (click)="savePaymentMethod()"
        [disabled]="savingPaymentMethod || !hasPaymentMethodChanges || loading"
      >
        <mat-spinner *ngIf="savingPaymentMethod" diameter="20" class="dc-btn-spinner"></mat-spinner>
        <mat-icon *ngIf="!savingPaymentMethod" class="btn-icon">save</mat-icon>
        <span>{{
          savingPaymentMethod
            ? ("saving" | translate)
            : ("settings.billing.savePaymentMethod" | translate)
        }}</span>
      </button>
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="onSubmit()"
        [disabled]="savingSettings || !hasChanges || loading"
      >
        <mat-spinner *ngIf="savingSettings" diameter="20" class="dc-btn-spinner"></mat-spinner>
        <mat-icon *ngIf="!savingSettings" class="btn-icon">save</mat-icon>
        <span>{{
          savingSettings ? ("saving" | translate) : ("save" | translate)
        }}</span>
      </button>
    </div>
  </mat-toolbar>

  <div class="billing-content">
  <div class="form-section" *ngIf="auth.isSuperAdmin || paymentMethod !== 'invoice'">
    <h3 class="section-title">
      {{ 'settings.billing.paymentMethod' | translate }}
    </h3>

    <div class="payment-method-container">
        <div class="payment-method-left">
        <mat-radio-group *ngIf="auth.isSuperAdmin" [value]="paymentMethod" (change)="onPaymentMethodChange($event.value)" color="primary">
          <mat-radio-button value="invoice">
            {{ 'settings.billing.invoice' | translate }}
          </mat-radio-button>
          <mat-radio-button value="card">
            {{ 'settings.billing.card' | translate }}
          </mat-radio-button>
        </mat-radio-group>

        <div class="payment-buttons">
          <div *ngIf="isUpfrontPaymentPastDue()" class="pending-change-container">
            <button 
              mat-raised-button 
              color="warn" 
              type="button" 
              (click)="openPaymentModal()"
              [disabled]="isProcessingPayment" 
              class="payment-button past-due-button">
              <mat-spinner *ngIf="isProcessingPayment" diameter="20" class="dc-btn-spinner"></mat-spinner>
              <mat-icon *ngIf="!isProcessingPayment" class="btn-icon">payment</mat-icon>
              <span>{{ 'settings.billing.payOutstandingBalance' | translate }}</span>
            </button>
            <div class="pending-change-disclaimer">
              {{ 'settings.billing.pastDueWarning' | translate }}
            </div>
          </div>
          
          <div *ngIf="!isUpfrontPaymentPastDue() && isUpfrontPaymentWithActiveSubscription() && paymentMethod === 'card'" class="pending-change-container">
            <button 
              mat-raised-button 
              color="primary" 
              type="button" 
              (click)="openPaymentModal()"
              [disabled]="isProcessingPayment" 
              class="payment-button">
              <mat-spinner *ngIf="isProcessingPayment" diameter="20" class="dc-btn-spinner"></mat-spinner>
              <mat-icon *ngIf="!isProcessingPayment" class="btn-icon">credit_card</mat-icon>
              <span>{{ 'settings.billing.proceedToStripePortal' | translate }}</span>
            </button>
            <div class="pending-change-disclaimer">
              {{ 'settings.billing.stripePortalDisclaimer' | translate }}
            </div>
          </div>

          <div *ngIf="!isUpfrontPaymentPastDue() && isUpfrontPaymentWithoutSubscription() && paymentMethod === 'card'" class="upfront-purchase-section">
            <div class="upfront-purchase-form">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'settings.billing.upfrontLicensePurchase.numberOfLicenses' | translate }}</mat-label>
                <input 
                  matInput 
                  type="number" 
                  [(ngModel)]="upfrontLicenseCount" 
                  (ngModelChange)="calculateUpfrontPrice()" 
                  [min]="upfrontMinLicenseCount"
                  [ngModelOptions]="{standalone: true}" />
                <mat-error *ngIf="upfrontHasLicenseCountError">
                  {{ 'settings.billing.upfrontLicensePurchase.minLicenseError' | translate }}
                </mat-error>
              </mat-form-field>

              <div class="upfront-price-summary" *ngIf="upfrontCalculatedPrice > 0">
                <p class="subdomains-info">
                  <mat-icon>info</mat-icon>
                  {{ 'settings.billing.licensesCoverAllDomainsInfo' | translate }}
                </p>
                <div class="price-row-header">
                  <span class="price-label">{{ 'settings.billing.upfrontLicensePurchase.totalPrice' | translate }}:</span>
                  <span class="price-value">{{ upfrontCalculatedPriceWithVat | number:'1.2-2' }} {{ form.get('currency')?.value || billingSettings?.currency || 'USD' }}</span>
                </div>
                <div class="price-details">
                  <div class="price-detail-item">
                    <div class="price-detail-row">
                      <span>{{ 'settings.billing.upfrontLicensePurchase.numberOfLicenses' | translate }}:</span>
                      <span>{{ upfrontLicenseCount }}</span>
                    </div>
                  </div>
                  <div class="price-detail-row">
                    <span>{{ 'settings.billing.upfrontLicensePurchase.pricePerLicense' | translate }}:</span>
                    <span>{{ getUpfrontPricePerLicense() }} {{ form.get('currency')?.value || billingSettings?.currency || 'USD' }}</span>
                  </div>
                  <div class="price-detail-row" *ngIf="upfrontHasVat">
                    <span>VAT ({{ form.get('vatRate')?.value || billingSettings?.vatRate || 0 }}%):</span>
                    <span>{{ upfrontVatAmount | number:'1.2-2' }} {{ form.get('currency')?.value || billingSettings?.currency || 'USD' }}</span>
                  </div>
                </div>
                <div class="disclaimer-inline" *ngIf="billingSettings?.billingMode !== 'legacy'">
                  {{ 'settings.billing.upfrontLicensePurchase.disclaimer' | translate }}
                </div>
              </div>

              <button 
                mat-raised-button 
                color="primary" 
                type="button" 
                (click)="openPaymentModal()"
                [disabled]="paymentMethod !== 'card' || isProcessingPayment || upfrontHasLicenseCountError || (form.get('price')?.value || billingSettings?.price || 0) <= 0" 
                class="payment-button">
                <mat-spinner *ngIf="isProcessingPayment" diameter="20" class="dc-btn-spinner"></mat-spinner>
                <mat-icon *ngIf="!isProcessingPayment" class="btn-icon">credit_card</mat-icon>
                <span>{{ 'settings.billing.upfrontLicensePurchase.proceed' | translate }}</span>
              </button>
            </div>
          </div>

          <button 
            *ngIf="!isUpfrontPaymentPastDue() && (!isUpfrontPayment() || (isUpfrontPaymentWithActiveSubscription() && paymentMethod !== 'card'))"
            mat-raised-button 
            color="primary" 
            type="button" 
            (click)="openPaymentModal()"
            [disabled]="paymentMethod !== 'card' || isProcessingPayment" 
            class="payment-button">
            <mat-spinner *ngIf="isProcessingPayment" diameter="20" class="dc-btn-spinner"></mat-spinner>
            <mat-icon *ngIf="!isProcessingPayment" class="btn-icon">credit_card</mat-icon>
            <span>{{ paymentMethod === 'card' ? ('settings.billing.proceedToPayment' | translate) : ('settings.billing.selectCardOption' | translate) }}</span>
          </button>
          
          <button 
            *ngIf="!isUpfrontPaymentPastDue() && !isUpfrontPayment() && isYearlyPlanWithExistingPayment()"
            mat-raised-button 
            color="accent" 
            type="button" 
            (click)="openAdditionalLicensesDialog()"
            [disabled]="paymentMethod !== 'card' || isProcessingPayment" 
            class="payment-button additional-licenses-button">
            <mat-spinner *ngIf="isProcessingPayment" diameter="20" class="dc-btn-spinner"></mat-spinner>
            <mat-icon *ngIf="!isProcessingPayment" class="btn-icon">add</mat-icon>
            <span>{{ 'settings.billing.purchaseAdditionalLicenses' | translate }}</span>
          </button>
          
          <button 
            *ngIf="!isUpfrontPaymentPastDue() && isUpfrontPaymentWithActiveSubscription()"
            mat-raised-button 
            color="accent" 
            type="button" 
            (click)="openChangeUpfrontLicensesDialog()"
            [disabled]="paymentMethod !== 'card' || isProcessingPayment" 
            class="payment-button change-licenses-button">
            <mat-spinner *ngIf="isProcessingPayment" diameter="20" class="dc-btn-spinner"></mat-spinner>
            <mat-icon *ngIf="!isProcessingPayment" class="btn-icon">edit</mat-icon>
            <span>{{ 'settings.billing.changeLicenses' | translate }}</span>
          </button>
          
          <div *ngIf="isUpfrontPaymentWithActiveSubscription() && ((billingSettings?.upfrontPayment?.pendingLicenseCount && billingSettings.upfrontPayment.pendingLicenseCount !== billingSettings.upfrontPayment.licenseCount) || billingSettings?.upfrontPayment?.pendingPeriod)" class="pending-change-container">
            <button 
              mat-raised-button 
              color="warn" 
              type="button" 
              (click)="cancelPendingLicenseChange()"
              [disabled]="isProcessingPayment" 
              class="payment-button cancel-pending-button">
              <mat-spinner *ngIf="isProcessingPayment" diameter="20" class="dc-btn-spinner"></mat-spinner>
              <mat-icon *ngIf="!isProcessingPayment" class="btn-icon">cancel</mat-icon>
              <span>{{ 'settings.billing.cancelPendingChange' | translate }}</span>
            </button>
            <div class="pending-change-disclaimer" *ngIf="getNextBillingCycleDate()">
              {{ 'settings.billing.pendingChangeEffectiveDate' | translate: { date: dateFormatService.formatDate(getNextBillingCycleDate()) } }}
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="form.get('planId')?.value === 'paid' && !isUpfrontPayment()" class="payment-method-right">
        <app-subscription-info-card
          [billingSettings]="billingSettings"
          [stats]="stats"
          [form]="form">
        </app-subscription-info-card>
      </div>
    </div>
  </div>

  <form [formGroup]="form" class="form-section" (ngSubmit)="onSubmit()">
    <h3 class="section-title">
      {{ 'settings.billing.yourPlan' | translate }}
    </h3>

    <div *ngIf="billingSettings?.pendingPlanName" class="pending-plan-notification">
      <mat-card class="pending-plan-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon class="warning-icon">schedule</mat-icon>
            {{ 'settings.billing.pendingPlanChange' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p class="pending-plan-info">
            {{ 'settings.billing.pendingPlanChangeMessage' | translate: { 
              planName: billingSettings.pendingPlanName, 
              date: dateFormatService.formatDate(billingSettings.pendingChangeDate) 
            } }}
          </p>
          <div class="pending-plan-details">
            <div class="detail-item">
              <strong>{{ 'settings.billing.newPlan' | translate }}:</strong> {{ billingSettings.pendingPlanName | titlecase }}
            </div>
            <div class="detail-item">
              <strong>{{ 'settings.billing.newPrice' | translate }}:</strong> {{ billingSettings.pendingPrice }}{{ billingSettings.pendingCurrency }}
            </div>
            <div class="detail-item">
              <strong>{{ 'settings.billing.subscriptionPeriod' | translate }}:</strong> {{ billingSettings.pendingSubscriptionPeriod | titlecase }}
            </div>
          </div>
        </mat-card-content>
        <mat-card-actions>
          <button mat-raised-button color="warn" (click)="cancelPendingPlanChange()" [disabled]="cancellingPlanChange">
            <mat-icon>cancel</mat-icon>
            {{ cancellingPlanChange ? ('settings.billing.cancelling' | translate) : ('settings.billing.cancelPlanChange' | translate) }}
          </button>
        </mat-card-actions>
      </mat-card>
    </div>

    <div class="price-row">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'settings.billing.planName' | translate }}</mat-label>
        <mat-select formControlName="planName" [disabled]="isPlanSelectDisabled">
          <mat-option *ngFor="let plan of availablePlans" [value]="plan">{{ plan | titlecase }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'settings.billing.subscriptionPeriod' | translate }}</mat-label>
        <mat-select formControlName="subscriptionPeriod">
          <mat-option value="monthly">{{ 'settings.billing.monthly' | translate }}</mat-option>
          <mat-option value="yearly">{{ 'settings.billing.yearly' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="price-row">
      <mat-form-field appearance="outline" class="price-field">
        <mat-label>{{ 'settings.billing.price' | translate }}</mat-label>
        <input matInput formControlName="price" type="number" step="0.01" min="0">
      </mat-form-field>

      <mat-form-field appearance="outline" class="currency-field">
        <mat-label>{{ 'settings.billing.currency' | translate }}</mat-label>
        <mat-select formControlName="currency" [disabled]="isUpfrontPaymentWithActiveSubscription() && !auth.isSuperAdmin">
          <mat-option *ngFor="let currency of currencies" [value]="currency">{{ currency }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'settings.billing.planId' | translate }}</mat-label>
      <input matInput [value]="form.get('planId')?.value | titlecase" disabled>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'settings.billing.subscriptionStartDate' | translate }}</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="subscriptionStartDate">
      <mat-hint>YYYY-MM-DD</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <div class="price-row" *ngIf="!isUpfrontPayment()">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'settings.billing.lastInvoiceUserCount' | translate }}</mat-label>
        <input matInput formControlName="lastInvoiceUserCount" type="number" min="0">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'settings.billing.currentUserCount' | translate }}</mat-label>
        <input matInput formControlName="currentUserCount" type="number" min="0">
      </mat-form-field>
    </div>

  </form>

  <form *ngIf="auth.isSuperAdmin" [formGroup]="form" class="form-section" (ngSubmit)="onSubmit()">
    <h3 class="section-title">
      {{ 'settings.billing.superAdminOptions' | translate }}
    </h3>

    <div class="price-row">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'settings.billing.basePrice' | translate }}</mat-label>
        <input matInput formControlName="basePrice" type="number" step="0.01" min="0">
        <mat-hint>{{ 'settings.billing.basePriceHint' | translate }}</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'settings.billing.invoiceUserCount' | translate }}</mat-label>
        <input matInput formControlName="invoiceUserCount" type="number" min="0">
        <mat-hint>{{ 'settings.billing.invoiceUserCountHint' | translate }}</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'settings.billing.margin' | translate }}</mat-label>
        <input matInput formControlName="margin" type="number" step="0.01" min="0" max="1">
        <mat-hint>{{ 'settings.billing.marginHint' | translate }}</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'settings.billing.discount' | translate }}</mat-label>
        <input matInput formControlName="discount" type="number" step="0.01" min="0" max="100">
        <mat-hint>{{ 'settings.billing.discountHint' | translate }}</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'settings.billing.discountValidUntil' | translate }}</mat-label>
        <input matInput [matDatepicker]="discountValidUntilPicker" formControlName="discountValidUntil">
        <mat-hint>{{ 'settings.billing.discountValidUntilHint' | translate }}</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="discountValidUntilPicker"></mat-datepicker-toggle>
        <mat-datepicker #discountValidUntilPicker></mat-datepicker>
      </mat-form-field>
    </div>
  </form>

  <form [formGroup]="form" class="form-section" id="billing-info-section" (ngSubmit)="onSubmit()">
    <h3 class="section-title">
      {{ 'settings.billing.contactInfo' | translate }}
    </h3>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'settings.billing.contactName' | translate }}</mat-label>
      <input matInput formControlName="contactName">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'settings.billing.contactPhone' | translate }}</mat-label>
      <input matInput formControlName="contactPhone">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'settings.billing.contactEmail' | translate }}</mat-label>
      <input matInput formControlName="contactEmail" type="email">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'settings.billing.companyName' | translate }}</mat-label>
      <input matInput formControlName="companyName">
    </mat-form-field>

    <div class="address-row">
      <app-country-select
        formControlName="country"
        [label]="'settings.billing.country' | translate"
      ></app-country-select>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'settings.billing.city' | translate }}</mat-label>
        <input matInput formControlName="city">
      </mat-form-field>
    </div>

    <div class="address-row">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'settings.billing.street' | translate }}</mat-label>
        <input matInput formControlName="street">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'settings.billing.streetNumber' | translate }}</mat-label>
        <input matInput formControlName="streetNumber">
      </mat-form-field>
    </div>

    <div class="address-row">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'settings.billing.postalCode' | translate }}</mat-label>
        <input matInput formControlName="postalCode">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'settings.billing.state' | translate }}</mat-label>
        <input matInput formControlName="state">
      </mat-form-field>
    </div>

    <div class="vat-number-row">
      <mat-form-field appearance="outline" class="vat-number-field">
        <mat-label>{{ 'settings.billing.vatNumber' | translate }}</mat-label>
        <input matInput formControlName="vatNumber" [errorStateMatcher]="errorStateMatcher">
        <mat-error *ngIf="form.get('vatNumber')?.hasError('invalidVAT')">
          {{ form.get('vatNumber')?.getError('invalidVAT')?.message }}
        </mat-error>
      </mat-form-field>
      
      <mat-checkbox formControlName="vatNotApplicable" color="primary" (change)="onVatNotApplicableChange($event.checked)" class="vat-not-applicable-checkbox">
        {{ 'settings.billing.vatNotApplicable' | translate }}
      </mat-checkbox>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'settings.billing.vatRate' | translate }}</mat-label>
      <input matInput formControlName="vatRate" type="number" step="1" min="0" max="100">
    </mat-form-field>
  </form>

  <div class="form-section section-report">
    <h3 class="section-title">
      {{ 'settings.billing.report' | translate }}
    </h3>

    <div *ngIf="auth.isSuperAdmin && isDevelopmentEnvironment" class="admin-actions">
      <div class="manual-report-buttons">
        <button
          mat-stroked-button
          color="primary"
          type="button"
          (click)="runManualMonthlyBillingReport()"
          [disabled]="isRunningMonthlyReport || isRunningYearlyReport || isRunningStripeCron"
          class="manual-report-button"
        >
          <mat-spinner *ngIf="isRunningMonthlyReport" diameter="20" class="dc-btn-spinner"></mat-spinner>
          <mat-icon *ngIf="!isRunningMonthlyReport" class="btn-icon">refresh</mat-icon>
          <span>{{ isRunningMonthlyReport ? ('running' | translate) : ('settings.billing.runMonthlyReport' | translate) }}</span>
        </button>
        
        <button
          mat-stroked-button
          color="primary"
          type="button"
          (click)="runManualYearlyBillingReport()"
          [disabled]="isRunningMonthlyReport || isRunningYearlyReport || isRunningStripeCron"
          class="manual-report-button"
        >
          <mat-spinner *ngIf="isRunningYearlyReport" diameter="20" class="dc-btn-spinner"></mat-spinner>
          <mat-icon *ngIf="!isRunningYearlyReport" class="btn-icon">refresh</mat-icon>
          <span>{{ isRunningYearlyReport ? ('running' | translate) : ('settings.billing.runYearlyReport' | translate) }}</span>
        </button>

        <button
          mat-stroked-button
          color="primary"
          type="button"
          (click)="runStripeCron()"
          [disabled]="isRunningStripeCron || isRunningMonthlyReport || isRunningYearlyReport"
          class="manual-report-button"
        >
          <mat-spinner *ngIf="isRunningStripeCron" diameter="20" class="dc-btn-spinner"></mat-spinner>
          <mat-icon *ngIf="!isRunningStripeCron" class="btn-icon">payment</mat-icon>
          <span>{{ isRunningStripeCron ? ('running' | translate) : ('settings.billing.runStripeCron' | translate) }}</span>
        </button>
      </div>
    </div>
    
    <div class="billing-stats-section">
    <div class="monthly-stats">
      <h3>{{ 'settings.billing.aggregatedStats' | translate }}</h3>
        <div
          class="table-container"
          [class.table-container--loading]="isLoadingStats || !stats"
          [class.table-container--empty]="!!stats && !stats.aggregated?.length"
        >
          <table mat-table [dataSource]="stats?.aggregated || []" class="mat-elevation-z0">
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>
              {{ form.get('subscriptionPeriod')?.value === 'yearly'
              ? ('settings.billing.yearlyDate' | translate)
              : ('settings.billing.lastDayOfMonth' | translate) }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element.date | date: 'dd.MM.yyyy' }}</td>
          </ng-container>

          <ng-container matColumnDef="numberOfEmployees">
            <th mat-header-cell *matHeaderCellDef>{{ 'settings.billing.numberOfAccounts' | translate }}</th>
            <td mat-cell *matCellDef="let element">{{ element.numberOfEmployees }}</td>
          </ng-container>

          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef>{{ 'settings.billing.serviceValue' | translate }}</th>
            <td mat-cell *matCellDef="let element">
              {{ element.price }} {{ element.currency }}
              <span *ngIf="element.vatRate > 0"> + VAT {{ element.vatRate }}%</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>{{ 'settings.billing.action' | translate }}</th>
            <td mat-cell *matCellDef="let element">
              <button 
                *ngIf="element.paymentFailed && element.stripeLogId && paymentMethod === 'card'"
                mat-raised-button 
                color="warn" 
                (click)="retryFailedPayment(element.stripeLogId)"
                class="retry-payment-btn">
                {{ 'settings.billing.retryPayment' | translate }}
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="getDisplayedColumns()"></tr>
          <tr mat-row *matRowDef="let row; columns: getDisplayedColumns();"></tr>
        </table>
        <div class="loading-wrapper" *ngIf="isLoadingStats || !stats">
          <app-loading></app-loading>
        </div>
        <div class="empty-state" *ngIf="stats && !stats.aggregated?.length">
          <mat-icon class="empty-state__icon">bar_chart</mat-icon>
          <p>{{ 'settings.billing.noReportData' | translate }}</p>
        </div>
      </div>

      <ng-container *ngIf="form.get('subscriptionPeriod')?.value === 'yearly'">
        <h3>{{ 'settings.billing.yearlyStats' | translate }}</h3>
          <h4>{{ currentDomain }}</h4>
          <div
            class="table-container"
            [class.table-container--loading]="isLoadingStats || !stats"
            [class.table-container--empty]="!!stats && !stats.yearly?.length"
          >
            <table mat-table [dataSource]="stats?.yearly || []" class="mat-elevation-z0">
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef>{{ 'settings.billing.yearlyDate' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.date | date: 'dd.MM.yyyy' }}</td>
            </ng-container>
            
            <ng-container matColumnDef="numberOfEmployees">
              <th mat-header-cell *matHeaderCellDef>{{ 'settings.billing.numberOfAccounts' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.numberOfEmployees }}</td>
            </ng-container>

            <ng-container matColumnDef="price">
              <th mat-header-cell *matHeaderCellDef>{{ 'settings.billing.serviceValue' | translate }}</th>
              <td mat-cell *matCellDef="let element">
                {{ element.price }} {{ element.currency }}
                <span *ngIf="element.vatRate > 0"> + VAT {{ element.vatRate }}%</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="getDisplayedColumns()"></tr>
            <tr mat-row *matRowDef="let row; columns: getDisplayedColumns();"></tr>
          </table>
          <div class="loading-wrapper" *ngIf="isLoadingStats || !stats">
            <app-loading></app-loading>
          </div>
          <div class="empty-state" *ngIf="stats && !stats.yearly?.length">
            <mat-icon class="empty-state__icon">bar_chart</mat-icon>
            <p>{{ 'settings.billing.noReportData' | translate }}</p>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="form.get('subscriptionPeriod')?.value !== 'yearly'">
        <h3>{{ 'settings.billing.monthlyStats' | translate }}</h3>
          <h4>{{ currentDomain }}</h4>
          <div
            class="table-container"
            [class.table-container--loading]="isLoadingStats || !stats"
            [class.table-container--empty]="!!stats && !stats.monthly?.length"
          >
            <table mat-table [dataSource]="stats?.monthly || []" class="mat-elevation-z0">
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef>{{ 'settings.billing.lastDayOfMonth' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.date | date: 'dd.MM.yyyy' }}</td>
            </ng-container>

            <ng-container matColumnDef="numberOfEmployees">
              <th mat-header-cell *matHeaderCellDef>{{ 'settings.billing.numberOfAccounts' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.numberOfEmployees }}</td>
            </ng-container>

            <ng-container matColumnDef="price">
              <th mat-header-cell *matHeaderCellDef>{{ 'settings.billing.serviceValue' | translate }}</th>
              <td mat-cell *matCellDef="let element">
                {{ element.price }} {{ element.currency }}
                <span *ngIf="element.vatRate > 0"> + VAT {{ element.vatRate }}%</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="getDisplayedColumns()"></tr>
            <tr mat-row *matRowDef="let row; columns: getDisplayedColumns();"></tr>
          </table>
          <div class="loading-wrapper" *ngIf="isLoadingStats || !stats">
            <app-loading></app-loading>
          </div>
          <div class="empty-state" *ngIf="stats && !stats.monthly?.length">
            <mat-icon class="empty-state__icon">bar_chart</mat-icon>
            <p>{{ 'settings.billing.noReportData' | translate }}</p>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="billingSettings?.subdomains && billingSettings.subdomains.length > 0">
        <h3>{{ 'settings.billing.subdomainStats' | translate }}</h3>
        <div *ngFor="let sd of billingSettings.subdomains" class="monthly-stats-subdomain">
          <h4>{{ sd.domain }}</h4>
            <div
              class="table-container"
              [class.table-container--loading]="isLoadingStats || !stats"
              [class.table-container--empty]="!!stats && !(stats.subdomains[sd.domain]?.length)"
            >
              <table mat-table [dataSource]="stats?.subdomains?.[sd.domain] || []" class="mat-elevation-z0">
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>
                  {{ form.get('subscriptionPeriod')?.value === 'yearly'
                  ? ('settings.billing.yearlyDate' | translate)
                  : ('settings.billing.lastDayOfMonth' | translate) }}
                </th>
                <td mat-cell *matCellDef="let element">{{ element.date | date: 'dd.MM.yyyy' }}</td>
              </ng-container>

              <ng-container matColumnDef="numberOfEmployees">
                <th mat-header-cell *matHeaderCellDef>{{ 'settings.billing.numberOfAccounts' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.numberOfEmployees }}</td>
              </ng-container>

              <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef>{{ 'settings.billing.serviceValue' | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.price }} {{ element.currency }}
                  <span *ngIf="element.vatRate > 0"> + VAT {{ element.vatRate }}%</span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <div class="loading-wrapper" *ngIf="isLoadingStats || !stats">
              <app-loading></app-loading>
            </div>
            <div class="empty-state" *ngIf="stats && !(stats.subdomains[sd.domain]?.length)">
              <mat-icon class="empty-state__icon">bar_chart</mat-icon>
              <p>{{ 'settings.billing.noReportData' | translate }}</p>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="billingSettings?.resellerClients && billingSettings.resellerClients.length > 0">
        <h3>{{ 'settings.billing.resellerClientStats' | translate }}</h3>
        <div *ngFor="let client of billingSettings.resellerClients" class="monthly-stats-subdomain">
          <h4>{{ client.domain }}</h4>
            <div
              class="table-container"
              [class.table-container--loading]="isLoadingStats || !stats"
              [class.table-container--empty]="!!stats && !(stats.resellerClients[client.domain]?.length)"
            >
              <table mat-table [dataSource]="stats?.resellerClients?.[client.domain] || []" class="mat-elevation-z0">
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>
                  {{ form.get('subscriptionPeriod')?.value === 'yearly'
                  ? ('settings.billing.yearlyDate' | translate)
                  : ('settings.billing.lastDayOfMonth' | translate) }}
                </th>
                <td mat-cell *matCellDef="let element">{{ element.date | date: 'dd.MM.yyyy' }}</td>
              </ng-container>

              <ng-container matColumnDef="numberOfEmployees">
                <th mat-header-cell *matHeaderCellDef>{{ 'settings.billing.numberOfAccounts' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.numberOfEmployees }}</td>
              </ng-container>

              <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef>{{ 'settings.billing.serviceValue' | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.price }} {{ element.currency }}
                  <span *ngIf="element.vatRate > 0"> + VAT {{ element.vatRate }}%</span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <div class="loading-wrapper" *ngIf="isLoadingStats || !stats">
              <app-loading></app-loading>
            </div>
            <div class="empty-state" *ngIf="stats && !(stats.resellerClients[client.domain]?.length)">
              <mat-icon class="empty-state__icon">bar_chart</mat-icon>
              <p>{{ 'settings.billing.noReportData' | translate }}</p>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    </div>
  </div>
</div>

  <div class="dbc1-loading dbc1-loading--overlay" *ngIf="loading">
    <app-loading></app-loading>
  </div>
</div>
